import React from 'react';

const ContactUs = () => {
    return (
        <div className="bg-gradient-to-br from-blue-50 via-white to-blue-100 py-4 px-4 sm:px-6 lg:px-8 flex flex-col justify-center min-h-[calc(100vh-200px)]">
            <div className="max-w-7xl mx-auto w-full relative z-10">
                <div className="text-center mb-2">
                    <h2><strong><span class="light-blue">Contact</span> Us </strong></h2>
                </div>

                <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
                    <div className="grid grid-cols-1 lg:grid-cols-3">

                        {/* Image Section */}
                        <div className="p-4 lg:p-6 flex items-center justify-center bg-blue-50">
                            <img
                                src="/images/contact_us_banner.png"
                                alt="Contact Us"
                                className="w-full h-auto max-w-sm object-contain drop-shadow-lg transition-transform duration-500 hover:scale-105"
                            />
                        </div>

                        {/* Contact Info Section */}
                        <div className="p-4 lg:p-6 space-y-4 flex flex-col justify-center">
                            <div>
                                <h3 className="text-2xl font-bold text-gray-900 mb-4">Get In Touch</h3>

                                <div className="space-y-4">
                                    {/* Address */}
                                    <div className="flex items-start space-x-4 group">
                                        <div className="flex-shrink-0 w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center group-hover:bg-blue-600 transition-colors duration-300">
                                            <i className="fa fa-home text-blue-600 text-lg group-hover:text-white transition-colors duration-300" aria-hidden="true"></i>
                                        </div>
                                        <div>
                                            <h4 className="text-lg font-semibold text-gray-900">Our Office</h4>
                                            <p className="mt-1 text-gray-600 leading-relaxed">
                                                Shop No 5, Kahan Park, Against Super Attitude Hair Salon, Opp. Arvind Park Society, Near BAPS Swaminarayn Mandir, Anil Starch Mill Road, Bapunagar, Ahmedabad -380024.
                                            </p>
                                        </div>
                                    </div>

                                    {/* Phone */}
                                    <div className="flex items-start space-x-4 group">
                                        <div className="flex-shrink-0 w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center group-hover:bg-blue-600 transition-colors duration-300">
                                            <i className="fa fa-phone text-blue-600 text-lg group-hover:text-white transition-colors duration-300" aria-hidden="true"></i>
                                        </div>
                                        <div>
                                            <h4 className="text-lg font-semibold text-gray-900">Phone</h4>
                                            <p className="mt-1">
                                                <a href="tel:+919510060682" className="text-gray-600 hover:text-blue-600 transition-colors font-medium">
                                                    +91 9510060682
                                                </a>
                                            </p>
                                        </div>
                                    </div>

                                    {/* Email */}
                                    <div className="flex items-start space-x-4 group">
                                        <div className="flex-shrink-0 w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center group-hover:bg-blue-600 transition-colors duration-300">
                                            <i className="fa fa-envelope text-blue-600 text-lg group-hover:text-white transition-colors duration-300" aria-hidden="true"></i>
                                        </div>
                                        <div>
                                            <h4 className="text-lg font-semibold text-gray-900">Email</h4>
                                            <p className="mt-1">
                                                <a href="mailto:nickoonjvanani@gmail.com" className="text-gray-600 hover:text-blue-600 transition-colors break-all font-medium">
                                                    nickoonjvanani@gmail.com
                                                </a>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Social Links */}
                            <div className="pt-4 border-t border-gray-100">
                                <h4 className="text-sm font-bold text-gray-900 uppercase tracking-widest mb-3">Follow Us</h4>
                                <div className="flex space-x-4">
                                    <a href="#" className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center text-gray-600 hover:bg-blue-600 hover:text-white hover:-translate-y-1 transition-all duration-300 shadow-sm text-sm">
                                        <i className="fab fa-facebook-f"></i>
                                    </a>
                                    <a href="#" className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center text-gray-600 hover:bg-pink-600 hover:text-white hover:-translate-y-1 transition-all duration-300 shadow-sm text-sm">
                                        <i className="fab fa-instagram"></i>
                                    </a>
                                    <a href="#" className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center text-gray-600 hover:bg-blue-400 hover:text-white hover:-translate-y-1 transition-all duration-300 shadow-sm text-sm">
                                        <i className="fab fa-twitter"></i>
                                    </a>
                                    <a href="#" className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center text-gray-600 hover:bg-blue-700 hover:text-white hover:-translate-y-1 transition-all duration-300 shadow-sm text-sm">
                                        <i className="fab fa-linkedin-in"></i>
                                    </a>
                                </div>
                            </div>
                        </div>

                        {/* Map Section */}
                        <div className="h-64 lg:h-auto w-full">
                            <iframe
                                title="Vanani Associates Location"
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3671.5831657346657!2d72.62497377482481!3d23.03907231571323!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e8696ca53def1%3A0xdbda7276452848ee!2sNikunj%20Vanani%20%26%20Associates!5e0!3m2!1sen!2sin!4v1733227032351!5m2!1sen!2sin"
                                className="w-full h-full border-0"
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                            ></iframe>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactUs;
